<template>
  <div>
    <v-container>
      <div class="mb-3">
        <h5>Survey by Agents</h5>
        <div class="py-3">
          <DashboardSelectChannel v-model="channel" @changeChannel="handleFetchData" />
        </div>
        <v-layout align-center wrap>
          <v-flex xs12 sm6>
            <multiselect
              v-model="filterPage"
              :options="childPageOptions"
              select-label
              selected-label
              placeholder="เลือกเพจ"
              label="pagename"
              style="margin-bottom: 4px; max-width: 300px"
              @input="handleFetchData"
            ></multiselect>
          </v-flex>
          <v-flex xs12 sm6 class="pa-2 text-xs-right">
            <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
              <v-icon>search</v-icon>
              &nbsp;
              {{ $t('advanced search') }}&nbsp;
              <em v-if="!showAdvancedSearch" class="fas fa-angle-down" />
              <em v-else class="fas fa-angle-up" />
            </v-btn>

            <v-btn outline color="primary" @click="handleExportButtonClick">
              <em class="fas fa-file-export mr-1" />
              {{ $t('export') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
      <div v-if="showAdvancedSearch" class="mb-4 py-2">
        <AdvancedSearch v-model="filter" @onSearch="handleSearch" />
      </div>

      <v-data-table
        disable-initial-sort
        :headers="headers"
        hide-actions
        :items="dataItems"
        :pagination="pagination"
        class="elevation-1 mt-3"
      >
        <template #items="{ item }">
          <td>{{ item.customer_name }}</td>
          <td>{{ item.agent }}</td>
          <td>{{ item.ticket_id }}</td>
          <td>{{ item.survey_sent_timestamp | DateFormat('DD/MM/YYYY HH:mm:ss') }}</td>
          <td>
            <template v-if="item.survey_submit_timestamp">
              {{ item.survey_submit_timestamp | DateFormat('DD/MM/YYYY HH:mm:ss') }}
            </template>
            <template v-else>-</template>
          </td>
          <td>{{ item.page }}</td>
          <td>
            <template v-if="item.channel == 'facebook'">
              <em class="fas fa-brands fa-facebook" />
            </template>
            <template v-else-if="item.channel == 'x'">
              <em class="fas fa-brands fa-x" />
            </template>
            <template v-else-if="item.channel == 'pantip'">
              <em class="fas fa-brands fa-pantip" />
            </template>
            <template v-else><em style="color: grey" class="fas fa-envelope" /></template>
          </td>
          <td>{{ item.osat_group || '-' }}</td>
          <td>{{ item.osat_score > 0 ? item.osat_score : '-' }}</td>
          <td>{{ item.nps_group || '-' }}</td>
          <td>{{ item.nps_score > 0 ? item.nps_score : '-' }}</td>
          <td>{{ item.verbatim || '-' }}</td>
          <td>{{ item.default_osat || '-' }}</td>
          <td>{{ item.default_nps || '-' }}</td>
        </template>
      </v-data-table>

      <v-layout class="mt-2">
        <v-spacer></v-spacer>
        <v-pagination
          v-model="pageNumber"
          :total-visible="6"
          :length="pagelength"
          @input="handleChangePage"
        ></v-pagination>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ttbApi from '@/api/ttb'
import { mapGetters } from 'vuex'
import multiselect from 'vue-multiselect'
import XLSX from 'xlsx'
import AdvancedSearch from './AdvancedSearch.vue'
import DashboardSelectChannel from '@/components/view/dashboard/DashboardSelectChannel'
import dayjs from 'dayjs'
import { DATETIME } from '@/constants/datetime'

export default {
  name: 'SurveyComponent',
  components: {
    AdvancedSearch,
    multiselect,
    DashboardSelectChannel
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pageTemp: 1,
      pageNumber: 1,
      dataItems: [],
      localPagination: {
        rowsPerPage: 10,
        ...this.pagination
      },
      headers: [
        { text: 'Customer name', value: 'customerName', sortable: false },
        { text: 'Agent', value: 'agent', sortable: false },
        { text: 'Ticket no.', value: 'ticketNo', sortable: false },
        { text: 'Survey sent date & time', value: 'surveySentDatetime', sortable: false },
        { text: 'Survey summit date & time', value: 'surveySummitDatetime', sortable: false },
        { text: 'Page', value: 'page', sortable: false },
        { text: 'Channel', value: 'channel', sortable: false },
        { text: 'Group OSAT (ANS)', value: 'groupOsatAns', sortable: false },
        { text: 'OSAT', value: 'osat', sortable: false },
        { text: 'Group NPS (ANS)', value: 'groupNpsAns', sortable: false },
        { text: 'NPS', value: 'nps', sortable: false },
        { text: 'Verbatim', value: 'verbatim', sortable: false },
        { text: 'Default OSAT', value: 'default_osat', sortable: false },
        { text: 'Default NPS', value: 'default_nps', sortable: false }
      ],
      filter: {},
      showAdvancedSearch: false,
      filterPage: null,
      channel: 'all',
      isExport: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        const total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    childPageOptions() {
      return this.$store.state.ttbChildPages
    }
  },
  mounted() {
    this.handleFetchData()

    if (!this.childPages) {
      this.$store.dispatch('loadChildPages')
    }
  },
  methods: {
    async handleFetchData() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const resposnse = await vm.getTicketSurvey()
        vm.$store.commit('CLEAR_LOADING')
        if (resposnse && resposnse.status === 200) {
          vm.dataItems = resposnse.data.data
          vm.total = resposnse.data.total
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    async getTicketSurvey() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          select_page_id: vm.filterPage ? vm.filterPage.pageid : null,
          channel: vm.channel,
          limit: vm.isExport ? vm.total : vm.limit,
          offset: vm.offset
        }

        if (this.filter.agent) {
          Object.assign(data, { agent: this.filter.agent })
        }
        if (this.filter.ticket_id) {
          Object.assign(data, { ticket_id: this.filter.ticket_id })
        }
        if (this.filter.nps_score) {
          Object.assign(data, { nps_score: this.filter.nps_score })
        }
        if (this.filter.osat_score) {
          Object.assign(data, { osat_score: this.filter.osat_score })
        }
        if (this.filter.survey_sent_from) {
          Object.assign(data, {
            survey_sent_from: dayjs(this.filter.survey_sent_from).format(DATETIME.DATE_FORMAT)
          })
        }
        if (this.filter.survey_sent_to) {
          Object.assign(data, {
            survey_sent_to: dayjs(this.filter.survey_sent_to).format(DATETIME.DATE_FORMAT)
          })
        }
        if (this.filter.survey_submit_from) {
          Object.assign(data, {
            survey_submit_from: dayjs(this.filter.survey_submit_from).format(DATETIME.DATE_FORMAT)
          })
        }
        if (this.filter.survey_submit_to) {
          Object.assign(data, {
            survey_submit_to: dayjs(this.filter.survey_submit_to).format(DATETIME.DATE_FORMAT)
          })
        }

        const response = await ttbApi.postGetTicketSurvey({ data })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    handleSearch() {
      this.offset = 0
      this.pageTemp = 1
      this.pageNumber = 1
      this.handleFetchData()
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pageTemp !== val) {
        vm.pageTemp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        vm.handleFetchData()
      }
    },
    async handleExportButtonClick() {
      const vm = this
      try {
        vm.isExport = true
        const response = await vm.getTicketSurvey()
        const requestData = response.data.data
        vm.isExport = false

        if (requestData == null) return
        const requests = requestData.map((el) => {
          return {
            'Survey Metadata - Start Date': el.survey_sent_timestamp
              ? dayjs(el.survey_sent_timestamp).format('DD/MM/YYYY HH:mm')
              : '-',
            'Survey Metadata - End Date': el.survey_submit_timestamp
              ? dayjs(el.survey_submit_timestamp).format('DD/MM/YYYY HH:mm')
              : '-',
            'Survey Metadata - Recorded Date': el.survey_submit_timestamp
              ? dayjs(el.survey_submit_timestamp).format('DD/MM/YYYY HH:mm')
              : el.survey_sent_timestamp
              ? dayjs(el.survey_sent_timestamp).format('DD/MM/YYYY HH:mm')
              : '-',

            'Customer Name': el.customer_name ? el.customer_name : '-',
            'Distribution Channel': el.page ? el.page : '-',
            channel: el.channel ? el.channel : '-',
            Agent: el.agent ? el.agent : '-',
            Language: el.lang ? el.lang.toUpperCase() : '-',
            '(Group) NPS Ans': el.nps_group ? el.nps_group : '-',
            'NPS Ans': el.nps_score ? el.nps_score : '-',
            OSAT: el.osat_group ? el.osat_group : '-',
            'OSAT Flag': el.osat_score ? el.osat_score : '-',
            Verbatim: el.verbatim ? el.verbatim : '-',
            'Default OSAT': el.default_osat ? el.default_osat : '-',
            'Default NPS': el.default_nps ? el.default_nps : '-',
            'Ticket No.': el.ticket_id ? el.ticket_id : '-'
          }
        })

        const heading = [
          [
            'Survey Metadata - Start Date',
            'Survey Metadata - End Date',
            'Survey Metadata - Recorded Date',
            'Customer Name',
            'Distribution Channel',
            'Channel',
            'Agent',
            'Language',
            '(Group) NPS Ans',
            'NPS Ans',
            'OSAT',
            'OSAT Flag',
            'Verbatim',
            'Default OSAT',
            'Default NPS',
            'Ticket No.'
          ]
        ]

        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `survey-by-agents.xlsx`)
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/Survey/index.vue